// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3p-4PSrt8XOLJCiu9syeGA","right":"_3NupDsra0h5wYelzuJVdwH"};